module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_12.6987f87f.jpg";